import { useEffect } from 'react'
import { redirectToOtherQuestionSet } from '@mortgage-pos/ui/utils/navigation'
import { QuestionSetSlug, LoanPurpose, Routes } from '@mortgage-pos/types'
import { useStoreState } from '@mortgage-pos/ui/store'
import { useVariation } from '../services/featureFlags'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import { redirectTo } from '@mortgage-pos/utils'

export default function useDefaultQuestionSetRedirect() {
  const questionSet = new URLSearchParams(window.location.search).get(
    'question-set'
  )

  const skipBorrowerPortal = useVariation(
    FEATURE_FLAG_TYPES.SKIP_BORROWER_PORTAL
  )

  const { mergedAnswers } = useStoreState((store) => store.answers)

  // Redirect to shortened flows or full flows
  useEffect(() => {
    if (
      mergedAnswers?.loanPurpose &&
      (!questionSet || questionSet === QuestionSetSlug.NTL)
    ) {
      let newQuestionSet =
        mergedAnswers.loanPurpose === LoanPurpose.Purchase
          ? QuestionSetSlug.PrePricingPurchase
          : QuestionSetSlug.PrePricingRefinance

      if (skipBorrowerPortal) {
        newQuestionSet =
          mergedAnswers.loanPurpose === LoanPurpose.Purchase
            ? QuestionSetSlug.FullPurchase
            : QuestionSetSlug.FullRefinance
      }

      redirectToOtherQuestionSet(newQuestionSet)
    } else if (
      // Redirect to welcome page
      skipBorrowerPortal &&
      !mergedAnswers?.loanPurpose &&
      questionSet === QuestionSetSlug.NTL
    ) {
      return redirectTo(`/${Routes.APP_1003}/welcome`)
    }
  }, [mergedAnswers.loanPurpose, questionSet])
}
